import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { CatalogApp } from '@/webapi/use-widget-catalog-api';
import { CompoundChange, WidgetChange } from '@/pkg/sdk';
import { conditional } from '@/utils/conditional';

export function getWidgetName(
  appsCatalog: CatalogApp[],
  change: EditorDeclarativeBlock,
): string {
  if (change.block.kind === `compound`) {
    const block = change.block.value as CompoundChange;
    if (block?.isAiComponent) {
      if (block.selectedAgent?.id === `section-modifier`) {
        return `AI Edited Block`;
      }
      return `AI Generated Block`;
    }
    return `Code Block`;
  }

  const widgetId = (change?.block?.value as WidgetChange)?.widgetId || ``;
  const widgets = appsCatalog
    .map((app) => app.widgets.find((widget) => widget.id === widgetId))
    .filter((widget) => !!widget);
  return widgets?.[0]?.name || `element`;
}

export function getCheckoutWidgetName(change: EditorDeclarativeBlock): string {
  return change?.checkoutWidgetManifest?.manifest?.name || `element`;
}

export function getWidgetDisplayName(
  appsCatalog: CatalogApp[],
  change: EditorDeclarativeBlock,
): string {
  return conditional(
    getWidgetName(appsCatalog, change),
    change.block.kind === `checkoutWidget`,
    getCheckoutWidgetName(change),
  );
}
